import { motion, useMotionValue, useSpring, useReducedMotion } from "framer-motion";

export const easeOut = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 48 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: reduce ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1, delay, ease: easeOut }}
    >
      {children}
    </motion.div>
  );
};

export const SectionTag = ({ children, testId }) => (
  <Reveal y={20} className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4512D]">
    <span className="inline-block h-px w-12 bg-[#D4512D]" aria-hidden="true" />
    <span data-testid={testId}>{children}</span>
  </Reveal>
);

export const Magnetic = ({ children, className = "", ...rest }) => {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 180, damping: 14, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 180, damping: 14, mass: 0.4 });
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    x.set((e.clientX - r.left - r.width / 2) * 0.22);
    y.set((e.clientY - r.top - r.height / 2) * 0.32);
  };
  const onLeave = () => {
    x.set(0);
    y.set(0);
  };
  return (
    <motion.div style={{ x: sx, y: sy }} onMouseMove={onMove} onMouseLeave={onLeave} className={className} {...rest}>
      {children}
    </motion.div>
  );
};
